import React from "react";
import rightArrow from "../../../assets/images/icons/flechaderecha.svg";

import "./searchBar.scss";

interface searchBarInterface {
    styles?: React.CSSProperties;
    callToAction?():void;
}

const SearchBar = ({styles, callToAction}: searchBarInterface) => {
    return (
        <div className="a-search-bar" id="a-search-bar-tag" style={ styles ?? styles }>
                <h2 className="a-search-bar__title">¿Qué formación estás buscando?</h2>
                <label className="a-search-bar__input-container">
                    <input className="a-search-bar__input" type="text" placeholder="Buscar"></input>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22.536"
                        height="22.536"
                        viewBox="0 0 22.536 22.536"
                        className="a-search-bar__input-svg"
                    >
                        <path
                            id="Trazado_38818"
                            data-name="Trazado 38818"
                            d="M22.223-3.053,16.667-8.684a8.882,8.882,0,0,0,1.99-4.28,9.335,9.335,0,0,0-.375-4.693A9.287,9.287,0,0,0,15.653-21.6a9.181,9.181,0,0,0-4.167-2.177,9.621,9.621,0,0,0-4.693.113A9.008,9.008,0,0,0,2.7-21.3,9.008,9.008,0,0,0,.337-17.206a9.621,9.621,0,0,0-.113,4.693A9.181,9.181,0,0,0,2.4-8.347,9.287,9.287,0,0,0,6.344-5.719a9.335,9.335,0,0,0,4.693.375,8.882,8.882,0,0,0,4.28-1.99l5.631,5.556a.751.751,0,0,0,.638.3.915.915,0,0,0,.676-.263.915.915,0,0,0,.263-.676A.751.751,0,0,0,22.223-3.053ZM9.384-7.108A7.286,7.286,0,0,1,5.63-8.121a7.571,7.571,0,0,1-2.74-2.74,7.286,7.286,0,0,1-1.014-3.754A7.286,7.286,0,0,1,2.89-18.37a7.571,7.571,0,0,1,2.74-2.74,7.286,7.286,0,0,1,3.754-1.014,7.286,7.286,0,0,1,3.754,1.014,7.571,7.571,0,0,1,2.74,2.74,7.286,7.286,0,0,1,1.014,3.754,7.286,7.286,0,0,1-1.014,3.754,7.571,7.571,0,0,1-2.74,2.74A7.286,7.286,0,0,1,9.384-7.108Z"
                            transform="translate(0.013 24.013)"
                            fill="#6f7287"
                        />
                    </svg>
                    <button className="a-search-bar__input-button" onClick={callToAction}>
                        <img className="a-search-bar__input-button__icon" src={rightArrow}/>
                    </button>
                </label>
            </div>
    );
};

export default SearchBar;